import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import GapTimers from "../../../../../components/Collections/GapTimers";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const breadcrumbStatic = [{
	name: 'KPI Scores',
	url: '/admin/kpi_scores',
	icon: 'dashboard'
}];

export default class Kpi_Scores extends Framework.Components.View {

	constructor(props) {
		super(props, 'Dispatch');
		this.state.week_view = false;
	}

	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Button style={{alignSelf: 'start'}} onClick={() => this.setState({week_view: !this.state.week_view})}>
						{this.state.week_view ? "Week View" : "Day View"}
					</Button>
					<Tab label="Dispatch" value="Dispatch"/>
					<Tab label="Helpdesk" value="Helpdesk"/>
					<Tab label="Hiring" value="Hiring"/>
					{/*<Tab label="Hiring" value="logs"/>*/}
				</Tabs>


				{this.state.tab === 'Dispatch' && <Collections.DispatcherScores key={this.state.week_view} week_view={this.state.week_view}/>}

				{this.state.tab === 'Helpdesk' && <Collections.HelpdeskScores key={this.state.week_view} week_view={this.state.week_view}/>}

				{this.state.tab === 'Hiring' && <Collections.HiringScores key={this.state.week_view} week_view={this.state.week_view}/>}

			</div>


		)
	}
}